import TitleBar11 from './titleBar11';
export default TitleBar11;
